import React, { useEffect, useState } from 'react';
import Auth from '@aws-amplify/auth';

const UserName = () => {
  const [email, setEmail] = useState('Account');

  useEffect(() => {
    let active = true;
    // The signed-in session already contains the staff email. Account navigation
    // must not depend on a fresh Cognito profile request or React Admin's cache.
    Auth.currentSession()
      .then((session) => {
        const value = session.getIdToken().decodePayload().email;
        if (active) setEmail(typeof value === 'string' && value ? value : 'Account');
      })
      .catch(() => {
        if (active) setEmail('Account');
      });
    return () => {
      active = false;
    };
  }, []);

  return <span>{email}</span>;
};

export default UserName;
